<div class="d-flex align-items-center justify-content-between mb-4 mx-xl-3">
    <h6 class="montserrat-medium text-gray-500">Define your channels location</h6>
    <button class="btn btn-lg btn-gray-500" (click)="navigateNextStep()"
        [disabled]="this.selectedChannels == null || this.selectedChannels.size == 0" *ngIf="!shouldDisableAllPointers">
        proceed
    </button>
</div>
<app-highlights *ngIf="campaign" [step]="2" [campaign]="campaign" [metrics]="metrics"></app-highlights>
<div class="d-xl-flex align-items-start justify-content-between">
    <div class="flex-grow-1 mx-xl-3 bg-gray-200 br-15 p-3">
        <div class="map-filters p-3">
            <form name="form" [formGroup]="form">
                <div class="row d-flex align-items-center">
                    <div class="col-4">
                        <mat-form-field class="form-group dark-input">
                            <mat-label>Country</mat-label>
                            <mat-select formControlName="country" (selectionChange)="onChangeCountry($event)"
                                panelClass="select-panel-down" [disableOptionCentering]="true">
                                <mat-option *ngFor="let country of locations.countries" [value]="country"
                                    [disabled]="isCountryDisabled(country)" class="text-capitalize"
                                    [ngClass]="{ 'text-muted': isCountryDisabled(country) }">
                                    {{ country.name }}{{ getCountryDisplaySuffix(country) }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="form-group dark-input city-field">
                            <mat-label>City</mat-label>
                            <mat-select formControlName="city" multiple
                                (selectionChange)="onCitySelectionChange($event)"
                                (openedChange)="onCityPanelToggled($event)"
                                panelClass="select-panel-down" [disableOptionCentering]="true">
                                <mat-option *ngIf="!shouldDisableAllPointers && selectedCountry.cities?.length"
                                    class="select-all" [class.mat-selected]="areAllCitiesSelected()"
                                    (click)="onToggleAllCities()" value="All">
                                    <mat-checkbox [checked]="areAllCitiesSelected()" (click)="$event.preventDefault()">
                                        Select All
                                    </mat-checkbox>
                                </mat-option>
                                <mat-option *ngFor="let city of selectedCountry.cities" [value]="city"
                                    class="text-capitalize">
                                    {{ city.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-checkbox formControlName="indoor" (change)="onIndoorOutdoorChecked()"
                            class="mr-4 montserrat-regular">
                            Indoor</mat-checkbox>
                        <mat-checkbox formControlName="outdoor" (change)="onIndoorOutdoorChecked()"
                            class="mr-4 montserrat-regular">
                            Outdoor</mat-checkbox>
                    </div>
                </div>
                <div class="row d-flex align-items-center">
                    <div class="col-4">
                        <div class="form-inline my-2 my-lg-0">
                            <mat-form-field class="form-group dark-input">
                                <mat-label>Search</mat-label>
                                <input class="form-control" matInput autocomplete="off" type="text" id="tosearchfor"
                                    (input)="filterChange()" placeholder="Search" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-4 btn-group btn-block">
                        <button (click)="toggledisplaymap()" id="showHideMap" class="btn btn-sm btn-dark mr-2 rounded">
                            {{ mapBtnTxt }}
                        </button>
                        <button (click)="toggledisplaySelected()" id="showHideSelected"
                            class="btn btn-sm btn-dark mr-2 rounded">
                            {{ showSelectedBtnTxt }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="map-holder position-relative h-100 w-100">
            <div class="selected-locations p-3" *ngIf="showMap && showSelected">
                <div class="text-gray text-small mb-3">Channels Location</div>
                <div class="location" *ngFor="let country of selectedChannelsLocation.countries | keyvalue">
                    <div class="country text-white text-uppercase montserrat-semi-bold bg-gray-500 p-3 text-center"
                        *ngIf="country.value && country.value.name">
                        {{ country.value.name }}
                    </div>
                    <div class="city px-3 py-2" *ngFor="let city of country.value.cities | keyvalue">
                        <div class="mb-3">
                            <img src="./assets/images/icons/common/placeholder-dark.svg" alt="city" title="city"
                                width="16" />
                            <span class="text-gray montserrat-bold ml-2">{{
                                city.value.name
                                }}</span>
                        </div>
                        <ul class="p-0 m-0">
                            <li *ngFor="let channel of city.value.channels" style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                ">
                                <span (click)="locateSelectedOnMap(country.key, city.key, channel.id)" title="locate">{{
                                    channel.name }}</span>
                                <div style="display: flex; align-items: center; gap: 5px">
                                    <app-channel-status-color-coding *ngIf="showChannelStatusDistinction()"
                                        [currentChannelStatus]="channel.status"></app-channel-status-color-coding>
                                    <span (click)="onRemoveChannel(channel.id, country.key, city.key)" [ngClass]="{
                                            disabled: shouldDisableAllPointers
                                        }">
                                        <div style="min-width: 16px">
                                            <img *ngIf="
                                                    channel.status !== ChannelStatus.CANCELLED &&
                                                    (!approvedChannelStatuses.includes(channel.status)
                                                    || !showChannelStatusDistinction()
                                                    || canEditApproved)
                                                " src="./assets/images/icons/common/times-solid.svg" alt="city"
                                                title="Remove channel" width="16" />
                                        </div>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div *ngIf="!showMap" style="max-height: 500px; width: 100%; overflow-y: auto">
                <!-- Shared channel detail card. `channel` is the raw channel object (markers pass m.options). -->
                <ng-template #channelCard let-channel="channel">
                    <div class="col-md-4" style="max-height: 300px">
                        <!-- Opens this channel's images in a new tab (T41049); Step 2 itself is left as is. -->
                        <button *ngIf="getChannelMainImage(channel); else noChannelImage" type="button"
                            class="channel-image-button" title="View images"
                            (click)="openChannelImages(channel.idChannel, $event)">
                            <img [src]="getChannelMainImage(channel)" class="channel-image" [alt]="channel.name" />
                        </button>
                        <ng-template #noChannelImage>
                            <div class="channel-image-placeholder">No image</div>
                        </ng-template>
                    </div>
                    <div class="col-md-8" style="height: 100%; width: 100%">
                        <div class="row">
                            <div class="col">
                                <h4 class="heading">{{ channel.name }}</h4>
                                <p class="subheading">
                                    {{ getLocationByChannel(channel.idChannel)?.countryName }}/{{
                                    getLocationByChannel(channel.idChannel)?.cityName }}
                                </p>
                                <p class="subheading">
                                    <span class="cursor-pointer" (click)="locateSelectedOnMap(
                                            getLocationByChannel(channel.idChannel)?.country,
                                            getLocationByChannel(channel.idChannel)?.city,
                                            channel.idChannel)">
                                        <img src="./assets/images/icons/common/placeholder-dark.svg" alt="city"
                                            title="city" width="16" />
                                        <span class="text-gray montserrat-bold ml-2">show on map</span>
                                    </span>
                                </p>
                            </div>
                            <div class="col text-right">
                                <ng-container *ngIf="isChannelSelected(channel.idChannel); else chooseBtn">
                                    <button
                                        *ngIf="!approvedChannelStatuses.includes(channel.status) || !showChannelStatusDistinction() || canEditApproved"
                                        class="btn btn-sm btn-danger mx-0"
                                        (click)="onRemoveChannel(channel.idChannel, channel.countryKey, channel.cityKey)"
                                        [disabled]="shouldDisableAllPointers">
                                        Remove
                                    </button>
                                    <button
                                        *ngIf="approvedChannelStatuses.includes(channel.status) && showChannelStatusDistinction() && !canEditApproved"
                                        class="btn btn-sm approved mx-0" [disabled]="true">
                                        {{ channel.status }}
                                    </button>
                                </ng-container>
                                <ng-template #chooseBtn>
                                    <button class="btn btn-sm btn-gray-500 mx-0"
                                        (click)="onChannelAdd(channel.idChannel, channel.name)"
                                        [disabled]="shouldDisableAllPointers">
                                        Choose
                                    </button>
                                </ng-template>
                            </div>
                        </div>
                        <p class="text-muted">{{ channel.description }}</p>
                        <div class="text-muted">
                            <table class="table table-sm">
                                <tr>
                                    <td>
                                        <span class="text-gray text-capitalize">resolution: </span>
                                        <span *ngIf="channel.groups.length == 1">{{ channel.groups[0].width }} *
                                            {{ channel.groups[0].height }}</span>
                                        <span *ngIf="channel.groups.length > 1">Many</span>
                                    </td>
                                    <td>
                                        <span class="text-gray text-capitalize">Screens: </span>
                                        <span class="montserrat-medium">{{ getTotalScreens(channel.groups) }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="text-gray text-capitalize">DPI: </span>
                                        <span class="montserrat-medium">
                                            <span *ngIf="channel.groups.length == 1">{{ channel.groups[0].dpi }}</span>
                                            <span *ngIf="channel.groups.length > 1">Many</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="text-gray text-capitalize">Screen Size: </span>
                                        <span class="montserrat-medium">
                                            <span *ngIf="channel.groups.length == 1">{{ channel.groups[0].screenSize
                                                }}</span>
                                            <span *ngIf="channel.groups.length > 1">Many</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr *ngIf="showSectionPerBillingMethod(channel); else cpmDetails">
                                    <td>
                                        <span class="text-gray text-capitalize">Type: </span>
                                        <span class="montserrat-medium">{{ channel.type }}</span>
                                    </td>
                                    <td>
                                        <span class="text-gray text-capitalize">Average Plays./Hour: </span>
                                        <span class="montserrat-medium">{{ getTotalAvgImpressionsPerHour(channel.groups)
                                            }}</span>
                                    </td>
                                </tr>
                                <tr *ngIf="showSectionPerBillingMethod(channel)">
                                    <td>
                                        <span class="text-gray text-capitalize">Slot Time: </span>
                                        <span class="montserrat-medium">{{ channel.groups[0].loopDuration /
                                            channel.groups[0].nbrSlotsPerLoop | number }} s</span>
                                    </td>
                                    <td>
                                        <span class="text-gray text-capitalize">Loop Time: </span>
                                        <span class="montserrat-medium">{{ channel.groups[0].loopDuration }} s</span>
                                    </td>
                                </tr>
                                <tr *ngIf="showSectionPerBillingMethod(channel)">
                                    <td colspan="2">
                                        <span class="text-gray text-capitalize">{{ getMarkerPricingMethod() }}:&nbsp;</span>
                                        <span class="montserrat-medium">{{ getMarkerPricing(channel) | currency:
                                            channel.currency?.code }}</span>
                                    </td>
                                </tr>
                                <ng-template #cpmDetails>
                                    <tr>
                                        <td>
                                            <span class="text-gray text-capitalize">Type: </span>
                                            <span class="montserrat-medium">{{ channel.type }}</span>
                                        </td>
                                        <td>
                                            <span class="text-gray text-capitalize">Slot Time: </span>
                                            <span class="montserrat-medium">{{ channel.groups[0].loopDuration /
                                                channel.groups[0].nbrSlotsPerLoop | number }} s</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="text-gray text-capitalize">{{ getMarkerPricingMethod()
                                                }}:&nbsp;</span>
                                            <span class="montserrat-medium">{{ getMarkerPricing(channel) | currency:
                                                channel.currency?.code }}</span>
                                        </td>
                                        <td>
                                            <span class="text-gray text-capitalize">Loop Time: </span>
                                            <span class="montserrat-medium">{{ channel.groups[0].loopDuration }} s</span>
                                        </td>
                                    </tr>
                                </ng-template>
                            </table>
                        </div>
                        <hr />
                    </div>
                </ng-template>

                <div *ngFor="let channel of allAvailableChannels" [hidden]="!showMap && !showSelected">
                    <div class="row shadow-sm p-3 mb-4 bg-white rounded" style="width: 100%; overflow: auto"
                        *ngIf="isChannelSelected(channel.idChannel)">
                        <ng-container [ngTemplateOutlet]="channelCard"
                            [ngTemplateOutletContext]="{ channel: channel }"></ng-container>
                    </div>
                </div>
                <div *ngFor="let channel of markers">
                    <div class="row shadow-sm p-3 mb-4 bg-white rounded border" style="width: 100%; overflow: auto"
                        *ngIf="!isChannelSelected(channel.options.idChannel)">
                        <ng-container [ngTemplateOutlet]="channelCard"
                            [ngTemplateOutletContext]="{ channel: channel.options }"></ng-container>
                    </div>
                </div>
            </div>

            <agm-map *ngIf="showMap" [latitude]="lat" [longitude]="lng" [zoom]="zoom" [disableDefaultUI]="false"
                [styles]="mapStyles" (mapReady)="onMapReady($event)" class="custom-agm-map" #AgmMap>
                <agm-marker-cluster [imagePath]="markerClustererImagePath" [gridSize]="50" maxZoom="18">
                    <agm-marker *ngFor="let m of markers"
                        [latitude]="m.lat" [longitude]="m.lng" [label]="" [agmFitBounds]="true"
                        [markerDraggable]="m.draggable" [iconUrl]="getIconUrl(m)">
                        <agm-snazzy-info-window [closeWhenOthersOpen]="true" [maxWidth]="300" [maxHeight]="360"
                            [isOpen]="isSnazzyInfoWindowOpened" [closeOnMapClick]="true" wrapperClass="map-popup">
                            <ng-template>
                                <div class="p-3 mt-4" style="font-size: 11px">
                                    <div class="media">
                                        <img [src]="m.options.image" alt="city" title="city" style="max-width: 100px"
                                            class="img-responsive mb-4 br-15" />
                                        <div class="media-body">
                                            <h6 class="pr-35 pl-2 montserrat-bold text-gray-500 mb-3">
                                                {{ m.options.name }}
                                            </h6>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between border-bottom pb-1 mb-1">
                                        <span class="text-gray text-capitalize">resolution</span>
                                        <span class="montserrat-medium">
                                            <span *ngIf="m.options.groups.length == 1">{{ m.options.groups[0].width }} *
                                                {{ m.options.groups[0].height }}</span>
                                            <span *ngIf="m.options.groups.length > 1">Many</span>
                                        </span>
                                    </div>
                                    <div class="d-flex justify-content-between border-bottom pb-1 mb-1">
                                        <span class="text-gray text-capitalize">Screens</span>
                                        <span class="montserrat-medium">{{
                                            getTotalScreens(m.options.groups)
                                            }}</span>
                                    </div>
                                    <div class="d-flex justify-content-between border-bottom pb-1 mb-1">
                                        <span class="text-gray text-capitalize">DPI</span>
                                        <span class="montserrat-medium">
                                            <span *ngIf="m.options.groups.length == 1">{{
                                                m.options.groups[0].dpi
                                                }}</span>
                                            <span *ngIf="m.options.groups.length > 1">Many</span>
                                        </span>
                                    </div>
                                    <div class="d-flex justify-content-between border-bottom pb-1 mb-1">
                                        <span class="text-gray text-capitalize">Screen Size</span>
                                        <span class="montserrat-medium">
                                            <span *ngIf="m.options.groups.length == 1">{{
                                                m.options.groups[0].screenSize
                                                }}</span>
                                            <span *ngIf="m.options.groups.length > 1">Many</span>
                                        </span>
                                    </div>
                                    <div class="d-flex justify-content-between border-bottom pb-1 mb-1">
                                        <span class="text-gray text-capitalize">Type</span>
                                        <span class="montserrat-medium">{{ m.options.type }}</span>
                                    </div>
                                    <div class="d-flex justify-content-between border-bottom pb-1 mb-1">
                                        <span class="text-gray text-capitalize">Average Plays./Hour</span>
                                        <span class="montserrat-medium">{{
                                            getTotalAvgImpressionsPerHour(m.options.groups)
                                            }}</span>
                                    </div>
                                    <div class="d-flex justify-content-between border-bottom pb-1 mb-1">
                                        <span class="text-gray text-capitalize">Slot Time</span>
                                        <span class="montserrat-medium">{{
                                            m.options.groups[0].loopDuration /
                                            m.options.groups[0].nbrSlotsPerLoop | number
                                            }}
                                            s</span>
                                    </div>
                                    <div class="d-flex justify-content-between border-bottom pb-1 mb-1">
                                        <span class="text-gray text-capitalize">Loop Time</span>
                                        <span class="montserrat-medium">{{ m.options.groups[0].loopDuration }} s</span>
                                    </div>
                                    <div class="d-flex justify-content-between pb-1 mb-1">
                                        <span class="text-gray text-capitalize">{{
                                            getMarkerPricingMethod()
                                            }}</span>
                                        <span class="montserrat-medium">{{
                                            getMarkerPricing(m.options)
                                            | currency: m.options.currency?.code
                                            }}</span>
                                    </div>
                                </div>
                                <div class="text-center px-3 mb-3">
                                    <button class="btn btn-sm btn-gray-500 mx-2"
                                        (click)="isChannelSelected(m.options.idChannel)
                                            ? onRemoveChannel(m.options.idChannel)
                                            : onChannelAdd(m.options.idChannel, m.options.name)"
                                        [disabled]="shouldDisableAllPointers">
                                        {{ isChannelSelected(m.options.idChannel) ? 'Remove' : 'Choose' }}
                                    </button>
                                </div>
                            </ng-template>
                        </agm-snazzy-info-window>
                    </agm-marker>
                </agm-marker-cluster>
            </agm-map>
        </div>
    </div>
</div>
<br />
<div class="d-flex align-items-center justify-content-end mb-4 mx-xl-3">
    <button class="btn btn-lg btn-gray-500" (click)="navigateNextStep()"
        [disabled]="this.selectedChannels == null || this.selectedChannels.size == 0" *ngIf="!previewMode">
        proceed
    </button>
</div>
